$("#text-note").hide()
window.findZipCode = function () {
    let zip_code = $("#text_zip_code").val()
    let data = new FormData()
    data.append('zipCode', zip_code)
    sendInfo('/find-zip-code', data, 'zip_code')
}

window.validaCouponCart = function () {
    let cupon = $("#cupon").val()
    let data = new FormData()
    data.append('code', cupon)
    sendInfo('/valida-code-coupon', data, 'coupon')
}

window.deleteCouponCart = function () {
    let cupon = $("#cupon").val()
    let data = new FormData()
    data.append('code', cupon)

    swal.fire({
        title: "¿Estas seguro?",
        text: "Tu cupón sera eliminado",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar!',
        cancelButtonText: 'Cancelar'
    }).then((result) => {
        if (result.isConfirmed) {
            sendInfo('/delete-code-coupon', data, 'coupon')
        }
    })
}

let typingTimeout;
window.visibleSearch = function () {
    clearTimeout(typingTimeout)
    $("#fa-search_").css("color", "red")
    typingTimeout = setTimeout(function () {
        $("#fa-search_").css("color", "black");
    }, 2000)
}

window.deleteItem = function (id, slug) {
    let strSlug = slug.replace(/["']/g, "");
    let data = new FormData()
    data.append('cartTempId', id)
    data.append('slug', strSlug)
    swal.fire({
        title: "¿Estas seguro?",
        text: "Tu artículo sera eliminado",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar!',
        cancelButtonText: 'Cancelar'
    }).then((result) => {
        if (result.isConfirmed) {
            sendInfo('/delete-item-cart_temp', data, 'delete-item')
        }
    })
}


function sendInfo(route, data, type,index) {
    $("#div_loading").addClass("loading-almadia")
    $.ajax({
        method: "POST",
        url: route,
        data: data,
        processData: false,
        contentType: false,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        success: function (response) {
            setTimeout(function () {
                $("#div_loading").removeClass("loading-almadia")
                if (type == "zip_code") {
                    $("#cost-text-shipping").html("Costo: $" + response.costo)
                    $("#text-delivery-time").html("Plazo: " + response.plazo)
                    $("#text-note").show()
                }
                if (type == "coupon") {
                    showInfoCoupon(response)
                }

                if (type == "delete-item") {
                    updateView(response)
                }

            }, 500);
        },
        error: function (errors, xhr, status,) {
            var indices = errors.responseJSON.errors;
            $.each(indices, function (index, value) {
                $("#item-" + index + "-error").html(value).css('color', 'red');
            });
        }
    });
}

function showInfoCoupon(response) {
    if (response.type === 'success') {
        document.getElementById('almadia_shopping_cart_total').innerHTML = response.cartResumen;
        document.getElementById('almadia_shopping_cart_gift').innerHTML = response.cartGift;
        showMessage(response)
    }
    if (response.type === 'error') {
        alertError(response.msg)
    }
}

function updateView(response) {
    if (response.show_view === "false") {
        window.location.href = window.location.protocol + '//' + window.location.hostname;
    }
    document.getElementById('almadia_shopping_cart_cart').innerHTML = response.cartView;
    document.getElementById('almadia_shopping_cart_total').innerHTML = response.cartResumen;
    document.getElementById('almadia_shopping_cart_gift').innerHTML = response.cartGift;
    showMessage(response)
}

function showMessage(response)
{
    if (response.show_message === "true") {
        alertSuccess(response.message)
    }
}

